var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.36642 11.7176C6.27753 11.7176 6.1942 11.7036 6.11642 11.6756C6.03865 11.648 5.96642 11.6009 5.89976 11.5342L3.03309 8.66758C2.91087 8.54536 2.85242 8.38691 2.85776 8.19224C2.86353 7.99802 2.92753 7.8398 3.04976 7.71758C3.17198 7.59536 3.32753 7.53424 3.51642 7.53424C3.70531 7.53424 3.86087 7.59536 3.98309 7.71758L6.36642 10.1009L12.0164 4.45091C12.1386 4.32869 12.2971 4.26758 12.4918 4.26758C12.686 4.26758 12.8442 4.32869 12.9664 4.45091C13.0886 4.57313 13.1498 4.73136 13.1498 4.92558C13.1498 5.12024 13.0886 5.27869 12.9664 5.40091L6.83309 11.5342C6.76642 11.6009 6.6942 11.648 6.61642 11.6756C6.53865 11.7036 6.45531 11.7176 6.36642 11.7176Z",
    fill: "#05603A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/check-green.4ef5347753a13b2e79b12e5e0b17aee2.svg";
export { ForwardRef as ReactComponent };